import './styles.css';
import { App } from './app.js';

const root = document.querySelector('#app');

if (!root) {
  throw new Error('No se ha encontrado el contenedor principal de la aplicación.');
}

const app = new App(root);

app.initialize().catch((error) => app.showFatalError(error));

if (import.meta.hot) {
  import.meta.hot.dispose(() => app.dispose());
}
